import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { ColorDisabled, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { AnyProgressBarWidget } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { isDrawerOpen, setDrawer } from "../../../store/slices/global";
import { setSelectedWidget } from "../../../store/slices/widgets";
import { IdPopover } from "../../../utils/IdPopover";
import { MoreMenuWidget } from "../MoreMenuWidget";

import { IgDiscountProgressBar } from "./IgDiscountProgressBar";

interface ProgressBarWidgetPreviewProps {
  progressBarWidget: AnyProgressBarWidget;
}

export const DiscountProgressBarWidgetPreview = ({
  progressBarWidget,
}: ProgressBarWidgetPreviewProps) => {
  const dispatch = useDispatch();
  const isWidgetDrawerOpen = useSelector(isDrawerOpen("widgetAction"));

  const toggleDrawer = () => {
    dispatch(setSelectedWidget(progressBarWidget));
    dispatch(setDrawer({ drawer: "widgetAction", open: !isWidgetDrawerOpen }));
  };

  return (
    <Grid container item xs={12} md={12} lg={6} key={progressBarWidget.id}>
      <IgPaper
        sx={{
          paddingTop: "15px",
          paddingBottom: "15px",
          width: "100%",
          padding: "30px 20px 30px 20px",
        }}
      >
        <Grid
          item
          container
          direction={"column"}
          rowSpacing={2}
          alignItems={"center"}
        >
          <Grid item container direction={"row"} alignItems={"center"}>
            <Grid item flex={1}>
              <IdPopover id={progressBarWidget.id}>
                <IgTypography sx={{ fontSize: "14px", fontWeight: 600 }}>
                  {progressBarWidget.name}
                </IgTypography>
              </IdPopover>
            </Grid>
            <Grid item>
              <MoreMenuWidget
                toggleDrawer={toggleDrawer}
                widgetType={"discountProgressBar"}
              />
            </Grid>
          </Grid>
          <Grid
            item
            container
            direction={"column"}
            rowSpacing={1}
            sx={{ height: "100%" }}
            justifyContent={"center"}
          >
            <Grid
              item
              container
              direction={"column"}
              rowSpacing={1}
              alignItems={"center"}
            >
              <Grid item textAlign={"center"}>
                <IgDiscountProgressBar
                  threshold={3}
                  configType={"desktop"}
                  progressBarWidget={progressBarWidget}
                />
                <IgTypography>Desktop</IgTypography>
              </Grid>
              <Grid
                item
                sx={{
                  borderTop: `solid 1px ${ColorDisabled.light}`,
                  marginTop: "10px",
                  paddingTop: "15px !important",
                  textAlign: "center",
                }}
              >
                <IgDiscountProgressBar
                  threshold={3}
                  configType={"mobile"}
                  progressBarWidget={progressBarWidget}
                />
                <IgTypography>Mobile</IgTypography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
